import {useGetAndSet} from "./useGetAndSet";
import {createSetInvoiceFiguresDataAction} from "../actions/dataActions";


export const useInvoiceFiguresData = (params, dataFresh) => {
    return useGetAndSet("invoices/figures", params, createSetInvoiceFiguresDataAction, dataFresh);
}